import { useCurrency } from '../context/CurrencyContext';

const OPTIONS = [
  { code: 'BRL', flag: 'br', label: 'R$', title: 'Preços em Real (R$) — Brasil' },
  { code: 'EUR', flag: 'pt', label: '€', title: 'Preços em Euro (€) — Portugal' },
  { code: 'USD', flag: 'us', label: 'US$', title: 'Preços em Dólar (US$) — Estados Unidos' },
];

export const CurrencyToggle = ({ compact = false, label = false }) => {
  const { currency, setCurrency } = useCurrency();

  if (compact) {
    return (
      <div className="flex items-center gap-2">
        {label && <span className="text-xs text-gray-400">Ver preços em:</span>}
        <div className="flex items-center gap-1 bg-zinc-800/70 border border-zinc-700 rounded-full p-1" data-testid="currency-toggle">
          {OPTIONS.map((opt) => (
            <button
              key={opt.code}
              type="button"
              onClick={() => setCurrency(opt.code)}
              title={opt.title}
              data-testid={`currency-${opt.code.toLowerCase()}`}
              className={`flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-medium transition-colors ${currency === opt.code ? 'bg-red-600 text-white' : 'text-gray-300 hover:text-white'}`}
            >
              <img src={`https://flagcdn.com/24x18/${opt.flag}.png`} alt={opt.label} className="w-5 h-auto rounded-[2px]" /> {opt.label}
            </button>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="w-full" data-testid="currency-toggle">
      <p className="text-sm text-gray-300 mb-2 text-center font-medium">Selecione a moeda para ver os preços:</p>
      <div className="grid grid-cols-3 gap-3 max-w-lg mx-auto">
        {OPTIONS.map((opt) => (
          <button
            key={opt.code}
            type="button"
            onClick={() => setCurrency(opt.code)}
            title={opt.title}
            data-testid={`currency-${opt.code.toLowerCase()}`}
            className={`flex items-center justify-center gap-2.5 px-4 py-3 rounded-xl border-2 transition-all ${
              currency === opt.code
                ? 'bg-red-600 border-red-500 text-white shadow-lg scale-[1.02]'
                : 'bg-zinc-800 border-zinc-700 text-gray-300 hover:border-red-500/60 hover:text-white'
            }`}
          >
            <img src={`https://flagcdn.com/48x36/${opt.flag}.png`} alt={opt.label} className="w-8 h-auto rounded-[3px] shadow" />
            <span className="text-base font-semibold">{opt.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default CurrencyToggle;
